import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f1a906b")

_pushScopeId("data-v-3f1a906b")
const _hoisted_1 = { class: "InvoiceDestination" }
const _hoisted_2 = { class: "InvoiceDestination__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "InvoiceDestination__body" }
const _hoisted_5 = { class: "body__block" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "block__subtext" }, "Наименование", -1)
const _hoisted_7 = { class: "block__text" }
const _hoisted_8 = { class: "body__block" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "block__subtext" }, "Контактное лицо", -1)
const _hoisted_10 = { class: "block__text" }
const _hoisted_11 = { class: "body__block" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "block__subtext" }, "Адрес", -1)
const _hoisted_13 = { class: "block__text" }
const _hoisted_14 = {
  key: 0,
  class: "body__block"
}
const _hoisted_15 = { class: "block__text" }
const _hoisted_16 = { class: "block__text--clickable" }
const _hoisted_17 = { class: "block__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_invoice_services = _resolveComponent("invoice-services")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.destination.title), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.destination.full_name) + " " + _toDisplayString(_ctx.toPhone(_ctx.destination.phone)) + " ", 1),
          (Boolean(_ctx.destination.additional_phone))
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createTextVNode(", " + _toDisplayString(_ctx.toPhone(_ctx.destination.additional_phone)), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.destination.full_address || 'Не указан'), 1)
      ]),
      (_ctx.isPvz)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, " ПВЗ " + _toDisplayString(_ctx.state.pvz && _ctx.state.pvz?.id ? `№ ${_ctx.state.pvz?.id}` : ''), 1),
            _createVNode("div", _hoisted_16, [
              _createVNode("span", _hoisted_17, _toDisplayString(_ctx.getPVZInfo), 1),
              (_ctx.state.is_failed)
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadPVZ && _ctx.loadPVZ(...args))),
                    class: "block__text text-link"
                  }, "Перезагрузить"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isCanShowNewAdditionalServices || _ctx.isCanShowAdditionalServices)
      ? (_openBlock(), _createBlock(_component_invoice_services, {
          key: 0,
          "new-additional-services": _ctx.newAdditionalServices,
          "additional-services": _ctx.additionalServices
        }, null, 8, ["new-additional-services", "additional-services"]))
      : _createCommentVNode("", true)
  ]))
})